import { Environment } from "../app/shared/data/models/environment.model";

export const environment: Environment = {
  production: false,
  apiUrl: 'https://web-api-uat.howdy.care/api',
  s3BaseUrl: 'https://howdy-web-app.s3.eu-west-1.amazonaws.com/',
  host: 'app-uat.howdy.care',
  ssoUrl: 'https://wlb-uat-g-sso.azurewebsites.net',
  raygunApiKey: 'zrOyVDspQgzzjdAet4cw'
};
